export const SLIDE_DEFAULT_WIDTH = 120;
export const SIDES_DEFAULT_NUMBER = 4;
